/* eslint-disable max-len */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Divider,
  Grid,
  Segment,
  Dropdown,
  Menu,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import AddLogo from '../../modals/AddLogo';
import LoadImage from '../../../components/LoadImage';
import NavBar from '../../../components/NavBar';
import { editRoutes } from '../navigations';
import config from '../../../../config';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class Logo extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    location: PropTypes.shape({
      hash: PropTypes.string,
      pathname: PropTypes.string,
    }),
    newFetch: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
  }

  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })

  static getPropsToState = (props) => {
    const project = props.data;
    return {
      project,
    };
  }

  constructor(props) {
    super(props);
    const menuIsTab = window.innerWidth <= 630;
    const state = Logo.getPropsToState(props);
    this.state = {
      ...state,
      menuIsTab,
      loading: false,
      hasChanges: false,
      showAddLogo: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillReceiveProps(nextProps) {
    const state = Logo.getPropsToState(nextProps);
    this.setState({ ...state });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }

  async getLogoToken() {
    const { t } = this.props;
    const { store } = this.context;
    let res;
    let token;
    try {
      res = await store.dispatch(fetchM('/logos/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return null;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
    }
    return token;
  }

  handleOnSubmit = async () => {
    const { t } = this.props;
    const { store } = this.context;
    const { project, hasChanges } = this.state;
    let res;
    await this.setLoading(true);
    if (hasChanges) {
      try {
        res = await store.dispatch(fetchM(`/projects/${this.props.id}/`, {
          credentials: 'include',
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': this.props.token,
          },
          body: JSON.stringify(project),
        }));
      } catch (err) {
        await this.setLoading(false);
        if (err && err.res && err.res.status >= 400 && err.res.status < 500) {
          const message = await err.res.text();
          store.dispatch(flashErrorMessage({ message }));
        } else {
          store.dispatch(flashErrorMessage({ message: err.message }));
        }
        return;
      }
      await this.setLoading(false);
      this.setState({ hasChanges: false }, () => {
        store.dispatch(push(`/projects/${this.props.id}/logo/`));
      });
      if (res) {
        let msg = t('Logo has been updated successfully', { ns: TRANSLATION_FILES.translation });
        if (!project.logoID && !project.logo) {
          msg = t('Logo has been removed successfully', { ns: TRANSLATION_FILES.translation });
        }
        store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: msg }));
      }
    }
  }

  handleResize = () => {
    const menuIsTab = window.innerWidth <= 630;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }

  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }

  handleAddLogo = (e, selectedLogo) => {
    e.preventDefault();
    const { project } = this.state;
    project.logoID = selectedLogo.id;
    project.logo = selectedLogo;
    this.setState({ project, hasChanges: true }, () => {
      this.handleOnSubmit();
    });
  }

  handleUploadLogo = async body => ({
    url: '/logos/',
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        // Let browser decide Content-Type
        'X-Csrf-Token': await this.getLogoToken(),
      },
      body,
    },
  })

  handleShowAddLogo = (e) => {
    e.preventDefault();
    this.setState({ showAddLogo: true });
  }

  handleCheckLogo = (logo) => {
    const { project } = this.state;
    return project.logoID === logo.id;
  }

  handleCloseAddLogo = async (e) => {
    e.preventDefault();
    this.setState({ showAddLogo: false });
  }

  handleRemoveLogo = async (e) => {
    e.preventDefault();
    const { project } = this.state;
    project.logoID = '';
    project.logo = null;
    this.setState({ project, hasChanges: true }, () => {
      this.handleOnSubmit();
    });
  }

  render() {
    const { auth, t } = this.props;
    const { project, loading } = this.state;
    const { pathname } = location;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(this.props.id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(l => ({
      ...l,
      text: t(l.text, { ns: l.text === 'Edit' ? TRANSLATION_FILES.translation : TRANSLATION_FILES.screens }),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
              : links.map((link, key) => (
                <Menu.Item
                  key={key}
                  name={link.text}
                  active={pathname === link.value}
                  onClick={e => this.handleMenu(e, link)}
                />
              ))
          }
        />
        <Dimmer style={{ zIndex: 1 }} active={loading} inverted>
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <Divider horizontal>Logo</Divider>
        <Grid columns="equal" centered verticalAlign="middle">
          <Grid.Row>
            {project && project.logo && project.logo.key ?
              <Segment>
                <Grid.Column mobile={16}>
                  <LoadImage
                    picture={project.logo}
                    pictureSize={50}
                    extension="png"
                  />
                </Grid.Column>
              </Segment>
              : null}
            <Grid.Column mobile={16}>
              <Button
                onClick={this.handleShowAddLogo}
                primary
                icon="add"
                content={project && project.logoID ? t('Replace', { ns: TRANSLATION_FILES.screens }) : t('Add', { ns: TRANSLATION_FILES.screens })}
              />
              {project && project.logoID ?
                <Button
                  onClick={this.handleRemoveLogo}
                  disabled={loading}
                  negative
                  primary
                  icon="remove"
                  content={t('Remove', { ns: TRANSLATION_FILES.screens })}
                />
                : null
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <AddLogo
          ref={(ref) => { this.logoModal = ref; }}
          open={this.state.showAddLogo}
          onClose={this.handleCloseAddLogo}
          onConfirm={this.handleAddLogo}
          onUpload={this.handleUploadLogo}
          onCheck={this.handleCheckLogo}
          isLoading={loading}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Logo.mapStateToProps)(Logo));



// WEBPACK FOOTER //
// ./src/containers/Project/Logo/index.jsx